// eslint-disable-next-line no-use-before-define
import { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'
import { usePosition } from 'use-position'

import { TSearchBarFormSearchParams } from 'src/refactor/components/SearchBarForm'

import { client } from 'src/api'
import { useGlobalState } from 'src/context/global'
import { CATEGORY } from '../../../../helpers/constants'

export const useSearchBarFunctions = () => {
  const [category, setCategory] = useState<CATEGORY>(CATEGORY.DOCTOR)

  const [state, actions] = useGlobalState()
  const { networkSelectionEnabled, template, shouldShowDisclaimer } =
    state.appConfig

  const history = useHistory()

  const { latitude, longitude } = usePosition(false, {
    enableHighAccuracy: true,
    timeout: Infinity,
    maximumAge: 0,
  })

  const disableTabButtons =
    networkSelectionEnabled && state.selectedPlan === null

  const handleNetworkSelected = (value: string) => {
    actions.onSelectPlan(value)
  }

  const planNetworkOptions = state.planNetworkMaps.map(
    (plan: { planName: string }) => ({
      value: plan.planName,
      label: plan.planName,
    })
  )

  const toggleCategory = (cat: CATEGORY) => {
    setCategory(prevCat => (prevCat === cat ? CATEGORY.NONE : cat))
  }

  useEffect(() => {
    const getZipCode = async () => {
      // check if geo location is granted
      const permissionStatus = await navigator?.permissions?.query({
        name: 'geolocation',
      })
      const hasPermission = permissionStatus?.state

      if (hasPermission === 'granted' || (latitude && longitude)) {
        await client.getZipCode(latitude as number, longitude as number)
      }
    }

    getZipCode()
  }, [latitude, longitude])

  const onSubmit = ({
    specialtyCode,
    name,
    placeId,
    addressLabel,
  }: TSearchBarFormSearchParams) => {
    const categoryQuery = `category=${category ?? CATEGORY.DOCTOR}`
    const specialtyQuery = specialtyCode
      ? `serviceLines=${specialtyCode}`
      : undefined
    const textQuery = name ? `name=${name}` : undefined
    const placeIdQuery = placeId ? `placeId=${placeId}` : undefined
    const labelQuery = addressLabel ? `addressLabel=${addressLabel}` : undefined

    const queryString = [
      categoryQuery,
      specialtyQuery,
      textQuery,
      placeIdQuery,
      labelQuery,
    ]
      .filter(e => !!e)
      .join('&')

    history.push({
      pathname: '/results',
      search: `?${queryString}`,
    })
  }

  return {
    state,
    template,
    category,
    networkSelectionEnabled,
    shouldShowDisclaimer,
    disableTabButtons,
    planNetworkOptions,

    handleNetworkSelected,
    toggleCategory,
    onSubmit,
  }
}
